import React, { Component } from 'react';
import { Button, Modal, Row, Col, Label, } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import _ from "underscore";
import OrdersActionCreators from '../../../actions/OrdersActionCreators';
const RemoveShipmentModal = (props) => {
    const { t } = useTranslation();
    return (React.createElement(Modal, { show: props.show, bsSize: "sm", enforceFocus: false },
        React.createElement(Modal.Header, null,
            React.createElement(Modal.Title, null, t('REMOVE_SHIPMENT_ORDER'))),
        React.createElement(Modal.Footer, null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 5 }),
                React.createElement(Col, { xs: 7 },
                    React.createElement("div", { className: "flex flex-row" },
                        React.createElement("button", { className: "button button-green hover:bg-green-dark text-white mr-2", onClick: () => {
                                let updatedStaging = props.order.shipments_staging.slice();
                                const stagingToRemove = _.findWhere(props.order.shipments_staging, { _id: props._id });
                                if (stagingToRemove) {
                                    const idx = _.indexOf(props.order.shipments_staging, stagingToRemove);
                                    updatedStaging = [...updatedStaging.slice(0, idx), ...updatedStaging.slice(idx + 1)];
                                }
                                OrdersActionCreators.updateOrder(props.order._id, { shipments_staging: updatedStaging });
                                props.onClose();
                            } }, t('CONFIRM')),
                        React.createElement("button", { className: "button bg-white text-grey hover:text-grey-darker", onClick: () => {
                                props.onClose();
                            } }, t('CANCEL'))))))));
};
export default RemoveShipmentModal;
